/** @internal */
export class Lock {
  private _isLocked: boolean = false;
  private _waiting: (() => void)[] = [];

  async acquire(): Promise<void> {
    return new Promise((resolve) => {
      if (!this._isLocked) {
        this._isLocked = true;
        resolve();
      } else {
        this._waiting.push(resolve);
      }
    });
  }

  release(): void {
    if (!this._isLocked) {
      throw new Error("Cannot release a lock that is not acquired.");
    }
    this._isLocked = false;
    if (this._waiting.length > 0) {
      const next = this._waiting.shift();
      if (next) {
        this._isLocked = true;
        next();
      }
    }
  }
}
